// extracted by mini-css-extract-plugin
export default {"tableResponsive":"HistorialConsumo_tableResponsive__Hb4dA"};